import React, { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import RightPanel from '../../components/organisms/RightPanel'
import AbundanceEngineSubView from '../AbundanceEngineSubView'

const DEFAULT_STATE = { open: false, bindings: {} }
const AbundancePanelContext = createContext({})
export const useAbundancePanel = () => {
  return useContext(AbundancePanelContext)
}

function AbundanceViewPanel ({ viewPath, panelProps, children }) {
  const [open, setOpen] = React.useState(DEFAULT_STATE)
  const providerValue = useMemo(() => {
    return {
      open: (bindings) => setOpen({ open: true, bindings }),
      close: () => setOpen(DEFAULT_STATE)
    }
  }, [setOpen])

  return (
    <AbundancePanelContext.Provider value={providerValue}>
      <>
        {children}
        <RightPanel titleClassName='font-size-md' {...panelProps} open={open.open} showCloseButton suppressArrows toggleOpen={providerValue.close}>
          {open.open ? (
            <AbundanceEngineSubView viewPath={viewPath} bindings={open.bindings} />
          ) : null}
        </RightPanel>
      </>
    </AbundancePanelContext.Provider>
  )
}

AbundanceViewPanel.propTypes = {
  viewPath: PropTypes.string,
  children: PropTypes.node,
  panelProps: PropTypes.object
}

export default AbundanceViewPanel
